<template>
  <a-flex class="root">
    <div class="title">
      <p>
        {{ title }}
      </p>
    </div>
    <div class="tags_container">
      <a-flex class="tags_list">
        <tag-item
          v-for="(item, index) in items"
          :class="item.count > 0 && 'active'"
          :key="'quality-' + index"
        >
          {{ getFormatedLabel(item.name, item.count) }}
        </tag-item>
      </a-flex>
    </div>
  </a-flex>
</template>

<script setup>
  import TagItem from '@/components/tags/TagItem.vue';

  defineProps({
    title: String,
    items: {
      type: Array,
      default: () => [],
    },
  });

  const getFormatedLabel = (label, counter) => {
    if (counter > 1) {
      return `${label} (${counter})`;
    }

    return label;
  };
</script>

<style scoped lang="scss">
  @use "@/assets/styles/_colors.scss" as *;

  .root {
    background-color: $color-bg-secondary-grey;
    border-radius: 7px;
    flex-direction: column;
    max-width: 900px;
    padding: 20px;
    width: 100%;

    .title {
      color: $color-table-text-secondary;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }

    .tags_list {
      flex-wrap: wrap;
      gap: 4px;

      :deep(.tag) {
        background-color: $color-bg-primary-white;
        color: $color-text-primary;
        font-size: 12px;
        padding: 4px 10px !important;
        pointer-events: none;
        user-select: none;

        &:before {
          content: '#';
        }
      }

      .active {
        background-color: $color-bg-status-done;
        color: $color-bg-primary-white;
      }
    }
  }
</style>
